import { useEffect, useRef } from 'react';
/**
 * usePrevous hook takes the new value and
 * returns the previous value
 *
 * This hook is useful to check old and new props values
 * on each render of the component
 * @param value
 */
function usePrevious<T>(value: T): T|undefined {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export default usePrevious;
